import { render, staticRenderFns } from "./Powershell.vue?vue&type=template&id=cdfc4ef4&scoped=true&"
import script from "./Powershell.vue?vue&type=script&lang=js&"
export * from "./Powershell.vue?vue&type=script&lang=js&"
import style0 from "./Powershell.vue?vue&type=style&index=0&id=cdfc4ef4&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cdfc4ef4",
  null
  
)

export default component.exports